var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[_c('navbar'),_c('app-menu',{staticClass:"menu-container",style:({ width: _vm.menuBarWidth + 'px' })}),_c('div',{staticClass:"main-container",style:({
      marginLeft: _vm.isCollapse ? _vm.menuBarWidth + 20 + 'px' : _vm.menuBarWidth + 'px'
    })},[_c('app-main')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }